module.exports = __webpack_public_path__ + "media/images/rss_feed-d3fae3f71179432d89f7c50c713da61c.png";